export function AdminDashboardSkeleton({ activeSection }) {
  if (activeSection === 'auctions') {
    return <AdminAuctionOperationsSkeleton />
  }

  return (
    <div className="obc-admin__overview obc-dashboard__skeleton" aria-live="polite" aria-busy="true">
      <section className="obc-admin__kpis">
        {Array.from({ length: 4 }, (_, index) => (
          <article className="tactical-card obc-admin__kpi obc-skeleton-card" key={`admin-kpi-skeleton-${index}`}>
            <span className="obc-skeleton-line is-short" />
            <strong className="obc-skeleton-line is-value" />
            <small className="obc-skeleton-line" />
          </article>
        ))}
      </section>

      <section className="obc-admin__command-grid">
        {Array.from({ length: 4 }, (_, index) => (
          <div className="tactical-card obc-skeleton-card" key={`admin-action-skeleton-${index}`}>
            <span className="obc-skeleton-icon" />
            <span className="obc-skeleton-line is-title" />
            <span className="obc-skeleton-line" />
          </div>
        ))}
      </section>

      <div className="obc-admin__split obc-admin__split--wide">
        <DashboardListSkeleton title={activeSection === 'orders' ? 'Loading order operations' : 'Loading live operations'} cards={5} withImage />
        <DashboardListSkeleton title="Loading admin queue" cards={5} />
      </div>
    </div>
  )
}

function AdminAuctionOperationsSkeleton() {
  return (
    <div className="obc-admin__section obc-dashboard__skeleton obc-admin-auction-skeleton" aria-live="polite" aria-busy="true">
      <section className="tactical-card obc-admin__builder obc-auction-create-launcher obc-skeleton-card">
        <div>
          <span className="obc-skeleton-line is-short" />
          <h2 className="obc-skeleton-line is-title" />
          <p className="obc-skeleton-line" />
        </div>
        <span className="obc-skeleton-line obc-admin-auction-skeleton__button" />
      </section>

      <section className="obc-admin-auction-tabs" aria-label="Loading auction operations">
        <div className="obc-admin-auction-tabs__nav obc-admin-auction-skeleton__tabs">
          {Array.from({ length: 4 }, (_, index) => (
            <article className="obc-skeleton-card" key={`auction-tab-skeleton-${index}`}>
              <span className="obc-skeleton-icon" />
              <div>
                <span className="obc-skeleton-line is-title" />
                <span className="obc-skeleton-line" />
              </div>
              <span className="obc-skeleton-line is-short" />
            </article>
          ))}
        </div>

        <section className="tactical-card obc-admin__builder obc-auction-ops obc-skeleton-card">
          <div className="obc-admin__panel-head">
            <div>
              <h2 className="obc-skeleton-line is-title" />
              <span className="obc-skeleton-line" />
            </div>
            <span className="obc-skeleton-line obc-admin-auction-skeleton__button" />
          </div>

          <div className="obc-auction-ops__summary">
            {Array.from({ length: 4 }, (_, index) => (
              <article key={`auction-summary-skeleton-${index}`}>
                <span className="obc-skeleton-icon" />
                <div>
                  <strong className="obc-skeleton-line is-value" />
                  <span className="obc-skeleton-line is-short" />
                </div>
              </article>
            ))}
          </div>

          <div className="obc-auction-ops__toolbar obc-admin-auction-skeleton__toolbar">
            {Array.from({ length: 7 }, (_, index) => (
              <span className="obc-skeleton-line" key={`auction-filter-skeleton-${index}`} />
            ))}
          </div>

          <div className="obc-auction-ops__list">
            {Array.from({ length: 4 }, (_, index) => (
              <article className="obc-auction-ops__row obc-admin-auction-skeleton__row" key={`auction-row-skeleton-${index}`}>
                <span className="obc-skeleton-thumb" />
                <div className="obc-auction-ops__main">
                  <div className="obc-auction-ops__title-line">
                    <span className="obc-skeleton-line is-title" />
                    <span className="obc-skeleton-line is-short" />
                  </div>
                  <div className="obc-auction-ops__meta">
                    <span className="obc-skeleton-line is-short" />
                    <span className="obc-skeleton-line is-short" />
                    <span className="obc-skeleton-line is-short" />
                    <span className="obc-skeleton-line is-short" />
                  </div>
                  <div className="obc-auction-ops__numbers">
                    {Array.from({ length: 5 }, (_, itemIndex) => (
                      <span key={`auction-row-stat-skeleton-${index}-${itemIndex}`}>
                        <small className="obc-skeleton-line is-short" />
                        <b className="obc-skeleton-line" />
                      </span>
                    ))}
                  </div>
                </div>
                <div className="obc-auction-ops__actions">
                  {Array.from({ length: 6 }, (_, actionIndex) => (
                    <span className="obc-skeleton-line" key={`auction-action-skeleton-${index}-${actionIndex}`} />
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>
      </section>
    </div>
  )
}

export function DashboardListSkeleton({ cards = 3, title, withImage = false }) {
  return (
    <section className="tactical-card obc-dashboard__skeleton-panel">
      <div className="obc-dashboard__side-head">
        <h3>{title}</h3>
        <span className="obc-skeleton-line is-short" />
      </div>
      <div className="obc-dashboard__skeleton-list">
        {Array.from({ length: cards }, (_, index) => (
          <article key={`${title}-${index}`}>
            {withImage ? <span className="obc-skeleton-thumb" /> : null}
            <div>
              <span className="obc-skeleton-line is-title" />
              <span className="obc-skeleton-line" />
              <span className="obc-skeleton-line is-short" />
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}
